module.exports = __webpack_public_path__ + "img/115.d53a34f2.jpg";